// extracted by mini-css-extract-plugin
export default {"cover":"productCard_cover__tMmhq","v":"productCard_v__8RH8t"};